import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, Chip, LinearProgress, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import moment from 'moment/moment';

import { MISC_DATE_ISO_FORMAT, MISC_DATE_POLISH_FORMAT } from '../../../../../../core/constants';
import useNotification from '../../../../../../core/hooks/use_notification';
import { getCustomerBlockadeRegistriesNotificationData } from '../../../../../../core/utils/notification_utils';
import { getCustomerBlockadeRegistrySource } from '../../../../../common/utils/customer_utils';
import { CustomerBlockadeRegistrySourceEnum } from '../../../../../../core/enums/customer/customer';
import { getCustomerBlockadeRegistriesAction, getCustomerBlockadeRegistriesState } from '../../../../../../features/customer/get_customers_blockade_registries';
import DeleteCustomerBlockadeRegistryDialog from './delete_blocakde_registry_dialog';
import CreateCustomerBlockadeRegistryDialog from './create_blocakde_registry_dialog';

const CustomerBlockadeRegistryList = ({ customerId }) => {
    const dispatch = useDispatch();
    const { showErrorMessage } = useNotification();

    const getCustomerBlockadeRegistries = useSelector(getCustomerBlockadeRegistriesState);

    useEffect(() => {
        dispatch(getCustomerBlockadeRegistriesAction(customerId))
            .then(response => showErrorMessage(getCustomerBlockadeRegistriesNotificationData(response)));
    }, [customerId, dispatch, showErrorMessage]);

    return (
        <Box>

            <Stack direction="row" spacing={ 2 } mb={ 4 } alignItems="center">
                <CreateCustomerBlockadeRegistryDialog customerId={ customerId }/>
            </Stack>

            { getCustomerBlockadeRegistries?.loading && (
                <Box mb={ 2 }>
                    <LinearProgress/>
                </Box>
            ) }

            { getCustomerBlockadeRegistries?.data && (
                <Box>
                    <TableContainer component={ Paper } variant="outlined">
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow sx={ { '& th': { backgroundColor: 'slate.50', fontWeighlt: 600 } } }>
                                    <TableCell>Data utworzenia</TableCell>
                                    <TableCell align="center">Typ blokady</TableCell>
                                    <TableCell align="center">Powód</TableCell>
                                    <TableCell align="center" sx={ { width: 160 } }>Znieś blokadę</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { getCustomerBlockadeRegistries?.data?.map(registry => (
                                    <TableRow key={ registry?.id } hover>
                                        <TableCell>
                                            { moment(registry?.createdDate, MISC_DATE_ISO_FORMAT).format(MISC_DATE_POLISH_FORMAT) }
                                        </TableCell>
                                        <TableCell align="center">
                                            <Chip
                                                label={ getCustomerBlockadeRegistrySource(registry?.source) }
                                                color={ registry?.source === CustomerBlockadeRegistrySourceEnum.MANUAL.value ? 'primary' : 'default' }
                                                variant={ registry?.source === CustomerBlockadeRegistrySourceEnum.MANUAL.value ? 'filled' : 'outlined' }
                                                size="small"
                                                sx={ { fontWeight: 600 } }
                                            />
                                        </TableCell>
                                        <TableCell align="center" sx={ {
                                            maxWidth: 550,
                                            whiteSpace: 'normal',
                                            wordBreak: 'break-word'
                                        } }>
                                            { registry?.reason }
                                        </TableCell>
                                        <TableCell align="center">
                                            <DeleteCustomerBlockadeRegistryDialog
                                                id={ registry?.id }
                                                customerId={ customerId }/>
                                        </TableCell>
                                    </TableRow>
                                )) }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            ) }
        </Box>
    );
};

export default CustomerBlockadeRegistryList;
